//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import searchUtils from '~/mixins/search/search-utils'

export default {
  name: 'SearchOtherBoatTypes',
  mixins: [searchUtils],
  computed: {
    ...mapGetters({
      locale: 'lang/locale',
      boatTypePage: 'page/boatTypePage'
    }),
    boatType () {
      return this.boatTypePage.boatType
    },
    getBoatTypes () {
      return this.$store.state.data?.boat?.boatTypes?.filter(bt => (bt.active && bt.is_page) && bt.id !== this.boatType?.id).map((bt) => {
        const trans = bt.values.find(v => v.language.shortcode === this.locale) || bt.values[0]
        return {
          ...bt,
          slug: trans.db_slug,
          name: trans.name
        }
      })
    },
    hasBoatTypes () {
      return !!this.getBoatTypes.length
    }
  }
}
